import * as React from "react";
const SVGComponent = (props) => (
    <svg
        width={100}
        height={100}
        viewBox="0 0 525 525"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_8043_28220)">
            <path
                d="M516.2 437.6H507.5V140C507.5 120.8 491.7 105 472.5 105H437.5V78.8C437.5 76.5 436.6 74.2 434.9 72.6L364.9 2.6C363.3 1 361.1 0 358.7 0H113.7C99.4 0 87.5 11.9 87.5 26.3V105H52.5C33.3 105 17.5 120.8 17.5 140V437.5H8.3C3.4 437.5 0 441.7 0 446.2V481.2C0 505.4 19.6 525 43.7 525H481.2C505.3 525 525 505.4 525 481.3V446.3C525 441.4 521 437.5 516.2 437.6ZM437.5 157.5H455V402.5H437.5V157.5ZM367.5 29.9L407.6 70H376.3C371.3 70 367.5 66.3 367.5 61.3V29.9ZM105 26.3C105 21.3 108.8 17.5 113.8 17.5H350V61.3C350 75.7 361.9 87.5 376.3 87.5H420V402.5H105V26.3ZM35 140C35 130.2 42.7 122.5 52.5 122.5H87.4V140H61.2C56.4 140 52.4 143.9 52.4 148.8V411.3C52.4 416.1 56.3 420.1 61.2 420.1H463.7C468.5 420.1 472.5 416.2 472.5 411.3V148.8C472.5 144 468.6 140 463.7 140H437.4V122.5H472.4C482.3 122.5 489.9 130.2 489.9 140V437.5C338.1 437.4 186.6 437.5 34.9 437.5V140H35ZM87.5 157.5V402.5H70V157.5H87.5ZM341.2 455.1V463.8C341.2 468.8 337.5 472.6 332.5 472.6H192.5C187.5 472.6 183.8 468.8 183.8 463.8V455.1H341.2ZM507.5 481.3C507.5 496 495.9 507.5 481.2 507.5H43.7C29 507.5 17.5 496 17.5 481.3V455.1H166.3V463.8C166.3 478.2 178.1 490.1 192.5 490.1H332.5C346.9 490.1 358.7 478.2 358.7 463.8V455.1H507.5V481.3Z"
                fill="url(#paint0_linear_8043_28220)"
            />
            <path
                d="M358.8 297.5H166.3C164 297.5 161.7 298.4 160.1 300.1C158.4 301.7 157.5 304 157.5 306.3V341.3C157.5 346.1 161.5 350 166.3 350H358.8C361.2 350 363.4 349 365 347.4C366.6 345.8 367.5 343.6 367.6 341.2V306.2C367.5 301.5 363.6 297.5 358.8 297.5ZM350 332.5H175V315H350V332.5Z"
                fill="url(#paint1_linear_8043_28220)"
            />
            <path
                d="M329.9 133.8L268.6 72.6002C267.11 71.1102 265.23 70.2802 263.28 70.0902C262.76 70.0402 262.24 70.0402 261.72 70.0902C259.77 70.2802 257.89 71.1102 256.4 72.6002L195.2 133.8C189.72 139.18 193.34 148.4 200.81 148.79C200.97 148.8 201.14 148.8 201.3 148.8H236.3V253.8C236.3 258.55 239.96 262.36 244.64 262.59C244.79 262.59 244.95 262.59 245.1 262.59H280.1C280.22 262.59 280.33 262.59 280.45 262.59C285.04 262.35 288.7 258.45 288.7 253.8V148.8H323.8C324.3 148.8 324.78 148.76 325.25 148.69C325.55 148.64 325.85 148.58 326.14 148.5C327.59 148.11 328.85 147.36 329.86 146.38C333.12 143.19 333.71 137.55 329.9 133.8ZM280 131.3C275.2 131.3 271.2 135.2 271.2 140V245H253.7V140C253.7 135.2 249.8 131.3 245 131.3H222.3L262.4 91.2002L262.45 91.2502L262.5 91.2002L302.7 131.3H280Z"
                fill="url(#paint2_linear_8043_28220)"
            />
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_8043_28220"
                x1={108.36}
                y1={-0.159996}
                x2={377.83}
                y2={577.73}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.09} stopColor="#01E9BD" />
                <stop offset={0.37} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_8043_28220"
                x1={192.14}
                y1={179.45}
                x2={286.69}
                y2={373.3}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.02} stopColor="#01E9BD" />
                <stop offset={0.06} stopColor="#01D5B9" />
                <stop offset={0.16} stopColor="#01A8B2" />
                <stop offset={0.25} stopColor="#0183AD" />
                <stop offset={0.35} stopColor="#0166A8" />
                <stop offset={0.45} stopColor="#0152A5" />
                <stop offset={0.54} stopColor="#0146A3" />
                <stop offset={0.64} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_8043_28220"
                x1={213.22}
                y1={44.2602}
                x2={340.48}
                y2={317.17}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.07} stopColor="#01E9BD" />
                <stop offset={0.09} stopColor="#01E3BC" />
                <stop offset={0.25} stopColor="#01AAB3" />
                <stop offset={0.39} stopColor="#017DAC" />
                <stop offset={0.52} stopColor="#015CA7" />
                <stop offset={0.63} stopColor="#0149A4" />
                <stop offset={0.7} stopColor="#0242A3" />
            </linearGradient>
            <clipPath id="clip0_8043_28220">
                <rect width={525} height={525} fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export default SVGComponent;
